import { TierartEnum, ValueLabelElement } from '@ps20-frontend/frontend-models';
import { convertDateFormatFromLocalStateToShortIso } from '@ps20-frontend/utils';
import { AnimalIllness, Tiergeschlecht, Tierhaltung } from '@ps20/bff-models';
import { IAppState } from '../appState';
import {
  DogBreedType,
  DogSize,
  Versicherungsnehmer,
} from '../reducers/versicherungsnehmer.reducer';

export const selectVersicherungsnehmer = (state: IAppState): Versicherungsnehmer =>
  state.versicherungsnehmer;

export const selectAnimalType = (state: IAppState): TierartEnum =>
  state.versicherungsnehmer.animalType;

export const selectAnimalGender = (state: IAppState): Tiergeschlecht =>
  state.versicherungsnehmer.animalGender;

export const selectAnimalName = (state: IAppState): string => state.versicherungsnehmer.animalName;

export const selectAnimalBirthDate = (state: IAppState): string => {
  if (state.versicherungsnehmer.animalBirthDate) {
    return convertDateFormatFromLocalStateToShortIso(state.versicherungsnehmer.animalBirthDate);
  }
  return null;
};

export const selectBreed = (state: IAppState): ValueLabelElement => state.versicherungsnehmer.breed;

export const selectDogBreeds = (state: IAppState): ValueLabelElement[] =>
  state.versicherungsnehmer.dogBreeds;

export const selectHorseBreeds = (state: IAppState): ValueLabelElement[] =>
  state.versicherungsnehmer.horseBreeds;

export const selectCatBreeds = (state: IAppState): ValueLabelElement[] =>
  state.versicherungsnehmer.catBreeds;

export const selectDogBreedType = (state: IAppState): DogBreedType =>
  state.versicherungsnehmer.dogBreedType;

export const selectDogMotherBreed = (state: IAppState): ValueLabelElement =>
  state.versicherungsnehmer.dogMotherBreed;

export const selectDogMotherBreedType = (state: IAppState): DogBreedType =>
  state.versicherungsnehmer.dogMotherBreedType;

export const selectDogSize = (state: IAppState): DogSize => state.versicherungsnehmer.dogSize;

export const selectCatKeepingType = (state: IAppState): Tierhaltung =>
  state.versicherungsnehmer.catKeepingType;

export const selectHasIllnesses = (state: IAppState): boolean =>
  state.versicherungsnehmer.hasIllnesses;

export const selectAvailablelIllnesses = (state: IAppState): AnimalIllness[] => {
  if (!state.versicherungsnehmer.animalIllnesses) {
    return [];
  }
  return state.versicherungsnehmer.animalType === TierartEnum.PFERD
    ? state.versicherungsnehmer.animalIllnesses.horseIllnesses
    : state.versicherungsnehmer.animalIllnesses.dogCatIllnesses;
};

export const selectSelectedIllnesses = (state: IAppState): AnimalIllness[] =>
  state.versicherungsnehmer.selectedIllnesses ?? [];

export const selectSelectedIllnessNames = (state: IAppState): string[] =>
  state.versicherungsnehmer.selectedIllnesses?.map(illness => illness.name) ?? [];

export const selectIsDenyingIllnessSelected = (state: IAppState): boolean => {
  return (
    state.versicherungsnehmer.selectedIllnesses?.filter(
      selectedIllness => selectedIllness.deniesInsurance,
    ).length > 0
  );
};

export const selectWantsCoverageUpgrade = (state: IAppState): boolean =>
  state.versicherungsnehmer.wantsCoverageUpgrade;

export const selectUseExistingWechselbaustein = (state: IAppState): boolean =>
  state.versicherungsnehmer.useExistingWechselbaustein;
